import { createSelectFilterChip } from 'components/filters/createSelectFilterChip';
import { invoiceStateOptions, formatOptionLabel } from './InvoiceStateField';

export const InvoiceStateFilterChip = createSelectFilterChip(invoiceStateOptions, {
  name: 'state',
  formatOptionLabel,
});
